export default "__VITE_ASSET__D9XbqDp2__"